import { Button, Tooltip } from '@mui/material';
import { useEffect,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import BDC from '../../Components/Docs/bdc';
import { buttonStyles } from '../../Components/docsAdministrative/JsObjectStyles';
//import Table from 'react-bootstrap/Table';
//import { useNavigate } from 'react-router-dom';
//import BDC from '../../Components/Docs/bdc';
import { MaterialTableComponent } from '../../Components/shared/ReusableSmallComponents';
//import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';
import { dureeBdcEnum, sourceMissionEnum, StatutsMisionEnum } from '../../data/Interfaces';
//import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../hooks/useNumberFormatting';
import useRole from '../../hooks/useRole';
import useUtilities from '../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, getStatutMissionEnCoursSiDateDebutPasEncoreCommencee, refPropositionCommerciale, searchLabelInEnumByValue, statutBdc, visibilityBdc } from '../../Utils/utils';
import { getMontatantTTC } from '../../Utils/utilsCraX';

//import BDC from '../../../Components/Docs/bdc';
//import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
//import { referenceOrdreMission } from '../../../Utils/utils';

function AllClientMissions(){
    const { addEuro4Decimal } = useNumberFormatting();
    const { i18n } = useTranslation();
    const columns =[
        {
            field: 'missionId',
            title: i18n.t('Réf. Mission'),
        },
        {
            field: 'expertId_',
            title: i18n.t('Réf. Expert'),
            // enableRowSpan: true
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom de l\'expert'),
            //enableRowSpan: true,
            //Filter: FilterForm,
        },
        {
            field: 'statutMission',
            title: i18n.t('Statut mission'),
            render: rowData =>
                i18n.t(getStatutMissionEnCoursSiDateDebutPasEncoreCommencee(
                    searchLabelInEnumByValue(StatutsMisionEnum, (rowData?.statutMission)),
                    rowData?.dateDebutMission,
                    // rowData?.isInterruptionEnCours
                )),
        },
        {
            field: 'titre',
            title: i18n.t('Intitulé de la mission'),
            // enableRowSpan: true
        },
        {
            field: 'dateDebutMission',
            title: i18n.t('Date début mission'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.dateDebutMission),
        },
        {
            field: 'dateFinMission',
            title: i18n.t('Date fin mission'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.dateFinMission),
        },
        {
            field: 'refBdcExpert',
            title: i18n.t('Réf. BDC'),
            render:  rowData => (
                <Button
                    variant='text'
                    style={{...buttonStyles(),...{color: visibilityBdc(rowData?.statutOrdreMission, rowData?.statutPropositionCommerciale, rowData?.statutMission)? '#9BA6E7' : '#214DCE' }}}
                    onClick={()=> {
                        setSelectedMission(rowData);
                        setOpenBdc(true);
                    }}
                    disabled={visibilityBdc(rowData?.statutOrdreMission, rowData?.statutPropositionCommerciale, rowData?.statutMission)}
                >
                    {rowData?.refBdcExpert}
                </Button>
            )
        },
        {
            field: 'statutBdc',
            title: i18n.t('Statut BDC'),
            render: rowData =>
                i18n.t(rowData?.statutBdc)
        },
        {
            field: 'dateDebBdc',
            title: i18n.t('Date début BDC'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateDebBdc)
        },
        {
            field: 'dateFinBdc',
            title: i18n.t('Date Fin BDC'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateFinBdc)
        },
        {
            field: 'nbJoursBDC',
            title: i18n.t('Nb de jours'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.nbJoursBDC,'j');
            }
        },
        {
            field: 'frequenceRenouvelement',
            title: i18n.t('Fréq. de renouvellement'),
            render:  rowData =>
                i18n.t(searchLabelInEnumByValue(dureeBdcEnum,rowData?.frequenceRenouvelement))
        },
        {
            field: 'tjClientHt',
            title: i18n.t('Taux journalier HT'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tjClientHt)
            // enableRowSpan: true
        },
        {
            field: 'tjClientTTC',
            title: i18n.t('Taux journalier TTC'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tjClientTTC)
            // enableRowSpan: true
        },
        {
            field: 'responsableOperationnel',
            title: i18n.t('Resp.Opérationnel'),

        },
        {
            field: 'chargeRecrutement',
            title: i18n.t('Chargé de recrutement'),
        },
        {
            field: 'motifInterruption',
            title: i18n.t('Motif d\'interruption'),
            render: rowData => {
                return (
                    <Tooltip title={rowData.dateEffective ? formatDateJJMMYYYY(rowData.dateEffective) :''}>
                        <p style={{margin:'0px'}}>{rowData.motifInterruption}</p>
                    </Tooltip>
                );
            }
        },
    ];
    const [selectedRow, setSelectedRow] = useState(null);
    const [missions, setMissions] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [missionsData,setMissionsData]=useState([]);

    const [selectedMission, setSelectedMission] = useState();
    const [openBdc, setOpenBdc] = useState(false);
    const { setBackdropOpen } = useUtilities();
    const location = useLocation();
    const role=useRole();
    const searchParams = new URLSearchParams(location.search);
    const [url, setUrl] = useState('');
    const [filtreMissionEncours, setFiltreMissionEncours] = useState(searchParams.get('filtreMissionEncours') === 'true');
    const [filtreMissionTermine, setFiltreMissionTermine] = useState(searchParams.get('filtreMissionTermine') === 'true');

    useEffect(() => {
        const currentUrl = window.location.href;
        setUrl(currentUrl);
    }, [location]);

    useEffect(() => {
        if(url && !url.toLowerCase().includes('filtremissiontermine') && !url.toLowerCase().includes('filtremissionencours') ){
            setFiltreMissionEncours(false);
            setFiltreMissionTermine(false);
        }
    }, [url]);
    useEffect(() => {
        if(role)
            getMissions();
    }, [filtreMissionTermine,filtreMissionEncours,role]);

    const mapBDC = (mission,bdc,isLastBDC) => {
        return (
            {
                'missionId': mission?.missionId,
                'nbJoursBDC': bdc?.nbJoursBDC,
                //'id': mission?._id,
                'bdcId': bdc.bdcId,
                'id':mission?._id,
                'source': searchLabelInEnumByValue(sourceMissionEnum,mission?.sourceMission),
                'titre': mission?.titre,
                'statutMission':mission?.statutMission,
                'createdAt': formatDateJJMMYYYY(mission?.createdAt),
                'esnId':mission?.esnId,
                'dateDebutMission': mission?.dateDebutMission,
                'dateFinMission': mission?.dateFinMission,
                'localisation': mission?.localisation,
                'refPropCommerciale': refPropositionCommerciale(mission?.missionId),
                'expertId_': mission?.expertId?.expertId,
                'expertId':mission?.expertId,
                'nomExpert': getNomPrenomClearFromPersoData(mission?.expertId?.persoData),
                // 'motifInterruption': mission?.interruptionClient?.isInterrupted ? mission?.interruptionClient?.motifInterruption : ' ',
                'motifInterruption': mission?.interruptionBackOffice?.wasAccepted == true ? mission?.interruptionBackOffice?.motifAcceptation ?? '' : '', //?? mission?.interruptionBackOffice?.motifRejet
                'dateEffective': mission?.interruptionBackOffice?.wasAccepted == true ? mission?.interruptionBackOffice?.dateEffective ?? '' : '',
                'lengthBdc': mission?.BDCs.length,
                'refCmdClient': bdc?.refCmdClient,
                'refBdcClient':bdc?.bdcId,
                'refBdcExpert':bdc?.bdcId,
                'refBdc':bdc?.bdcId,
                'statutOrdreMission':mission?.ordreDeMission?.statut,
                'statutPropositionCommerciale':mission?.propositionCommerciale?.statut,
                'statutBdc': statutBdc(
                    mission?.ordreDeMission?.statut,
                    mission?.propositionCommerciale?.statut,
                    mission?.statutMission,
                    isLastBDC
                ),
                'dateDebBdc': bdc?.dateDebutBDC,
                'dateFinBdc': bdc?.dateFinBDC,
                'frequenceRenouvelement': bdc?.frequenceRenouv,
                'tjClientHt': bdc?.tjClient,
                //PS: Ajouter TVA
                'tjClientTTC':getMontatantTTC(bdc.tjClient, bdc?.tauxTvaClient || (mission?.companyDataId?.donneeFacturation?.tauxTva ??mission?.esnId?.donneeFacturation?.tauxTva) ),
                'interruptionExpert':mission?.interruptionExpert,
                'interruptionClient':mission?.interruptionClient,
                'interruptionBackOffice':mission?.interruptionBackOffice,
                //'margeBrut':' ',
                //'margeNet':' ',
                'BDCs':bdc,
                'chargeRecrutement': getNomPrenomClearFromPersoData(bdc?.backOfficeId?.persoData),
                'responsableOperationnel':getNomPrenomClearFromPersoData(bdc?.responsableOperationnelId?.persoData ?? bdc?.responsableOperationnelEsnId?.persoData),
                'companyDataId':mission?.companyDataId ,
                'esnExpertOwnerId':mission?.esnExpertOwnerId,
                // * l interruption est-il traiter ou pas , mais sans aucun info sur la dateEffective s'est passee ou pas encore, donc on a cree le statut intermidiare dans le backend [BD] dirrectement
                // isInterruptionTraited: (mission?.interruptionBackOffice?.wasAccepted == true ||
                //     mission?.interruptionBackOffice?.wasAccepted == false) &&
                //     (!mission?.interruptionClient?.isInterrupted && !mission?.interruptionExpert?.isInterrupted),
                // * isInterruptionEnCours =  encours de demande
                // isInterruptionEnCours: mission?.interruptionClient?.isInterrupted || mission?.interruptionExpert?.isInterrupted,
            }

        );
    };

    useEffect(() => {
        if (missions) {
            let newData = [];
            // Loop through missions in reverse order
            missions.reverse().forEach((mission) => {
                mission.BDCs.forEach((bdc, index) => {
                    // Check if mission status is 'encours' or 'interruptionEnCours'
                    let isEncours = mission?.statutMission === 'encours' || mission?.statutMission === 'interruptionEnCours';
                    // Check if mission status is 'terminee' or 'interompu'
                    let isTermine = mission?.statutMission === 'terminee' || mission?.statutMission === 'interompu';

                    // Filter missions based on selected filters
                    if ((filtreMissionEncours && isEncours) ||
                        (filtreMissionTermine && isTermine) ||
                        (!filtreMissionEncours && !filtreMissionTermine)) {
                        let isLastBDC = mission.BDCs.length === index + 1;
                        newData.push(mapBDC(mission, bdc, isLastBDC));
                    }
                });
            });
            // Set the filtered missions data
            setMissionsData(newData);
        }
    }, [missions]);

    const handleClose = () => {
        setOpenBdc(false);
        getMissions();
    };

    useEffect(() => {
        if(role)
            getMissions();
    },[role]);

    const getMissions = async () => {
        try {
            setBackdropOpen(true);
            console.log('HELLO FROM the get Missions useEffect');
            const response = await axiosPrivate.get(`/mission/getMissions${role === 'esn' ? '?isAchat=true' : ''}`, {
                // signal: controller.signal
            });
            setMissions(response?.data);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error);
            setBackdropOpen(false);
        }
    };

    return (
        <>
            {/* <div className='frame5Profile'>
                {i18n.t('Missions et BDC')} &gt;  <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Missions')}</span>
            </div> */}
            {role === 'esn'
                ? (
                    <div className='frame5Profile'>
                        {i18n.t('Gestion des missions-HTH')}
                        &gt;
                        <span style={{ color: '#B0B0B0' }}>{i18n.t('Achat')}</span>
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Missions')}</span>
                    </div>
                )
                : (
                    <div className='frame5Profile'>
                        {i18n.t('Missions et BDC')}
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Missions')}</span>
                    </div>
                )
            }
            <div className='HomeFrame'>
                <div className='HomeFrameTitle'>
                    <h1 className='TitleHStyle'> {i18n.t('Missions et BDC')}</h1>
                </div>
                <MaterialTableComponent
                    columns={columns}
                    data={missionsData}
                    title={i18n.t('Missions et BDC')}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                        // * suivi Mission
                        //const a = await setMission(rowData);
                        //console.log(a);
                        // navigate('/client/suiviMission/Accueil');
                    }}
                    selectedRow={selectedRow}
                />
            </div>
            {openBdc &&
            <BDC
                handleClose={handleClose}
                mission={selectedMission}
                open={openBdc}
                role={'client'}
            />}
        </>
    );
}
export default AllClientMissions;
